export default "__VITE_ASSET__CQoP94oH__"